import { Avatar } from '@calendly/ui/components/avatar';
import { Item as MenuItem } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Highlighter from 'react-highlight-words';
import { FullStoryExclude } from '../../../../../shared/fullstory_privacy';
const styledAvatarCss = "s1nd3lqc";
const StyledAvatar = forwardRef((props, ref) => <Avatar ref={ref} {...props} className={classNames(styledAvatarCss, props.className)} />);
const highlightedCss = "hqzcuuo";
const Highlighted = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(highlightedCss, props.className)} />;
});
const Item = ({
  onClick,
  itemId,
  avatarLetter,
  avatarUrl,
  filterTerm,
  children
}) => <MenuItem onClick={() => onClick(itemId)}>
    <FullStoryExclude>
      <StyledAvatar size="tiny" letter={avatarLetter} src={avatarUrl} aria-hidden tabIndex={-1} />
      <div>
        {!filterTerm ? children : <Highlighter highlightTag={Highlighted} searchWords={[filterTerm]} textToHighlight={children} autoEscape />}
      </div>
    </FullStoryExclude>
  </MenuItem>;
export default Item;

require("./item.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./item.js");